/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  const logs = true;

  if (logs) {
    console.log("Custom JS loaded");
  }

  function secondaryActiveFilter() {
    let secondaryFilters = document.querySelector(
      ".collection__filters__secondary",
    );

    if (logs) {
      console.log("Checking secondary filters...");
    }

    if (secondaryFilters) {
      if (logs) {
        console.log("Secondary filters found");
      }

      let activeFilter = secondaryFilters.querySelector(
        "input.filter__input:checked",
      );

      if (activeFilter) {
        if (logs) {
          console.log("Secondary filters active");
        }
        secondaryFilters.setAttribute("open", "open");
      } else {
        if (logs) {
          console.log("Secondary filters inactive");
        }
        secondaryFilters.removeAttribute("open");
      }
    } else {
      if (logs) {
        console.log("No secondary filters found");
      }
    }
  }

  // Expose function to global scope for theme.dev.js to call
  window.secondaryActiveFilter = secondaryActiveFilter;

  // Sort handling for select dropdowns
  function initCustomSortHandling() {
    const sortSelects = document.querySelectorAll("select[data-input-sort]");

    if (logs) {
      console.log(`Found ${sortSelects.length} sort select elements`);
    }

    sortSelects.forEach((select) => {
      select.addEventListener("change", function (event) {
        if (logs) {
          console.log("Sort select changed to:", event.target.value);
        }

        // Find the parent form and trigger the input event for AJAX updates
        const form = event.target.closest("form[data-collection-filters-form]");
        if (form) {
          // Update any hidden sort_by inputs in the form
          const hiddenSortInputs = form.querySelectorAll(
            'input[name="sort_by"]',
          );
          hiddenSortInputs.forEach((input) => {
            input.value = event.target.value;
            input.disabled = false;
          });

          // Trigger the form input event for AJAX processing
          form.dispatchEvent(new Event("input", { bubbles: true }));

          if (logs) {
            console.log("Form input event dispatched for sort change");
          }
        }
      });
    }); 
  }

  // Expose sort function to global scope
  window.initCustomSortHandling = initCustomSortHandling;

  // Run on page load
  document.addEventListener("DOMContentLoaded", () => {
    secondaryActiveFilter();
    initCustomSortHandling();
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

 // ---------------------------------------------------------------------------
  // Mage Loyalty: silent cart refresh
  //
  // When a customer clicks "Add to cart" in the Mage sidebar (wishlist / saved
  // from cart), Mage adds via /cart/add.js then calls window.__mageRefreshCart().
  // Palo Alto's window.cart.getCart() repaints the whole drawer (items, price,
  // count, progress bar) but always ends by opening it. We run getCart() with
  // openCartDrawer() temporarily no-op'd so the cart updates in the background
  // and the drawer stays closed.
  // ---------------------------------------------------------------------------
  (function () {
    var SECTION_URL = '/cart?section_id=api-cart-items';
    var RESTORE_SAFETY_MS = 8000;
    var queue = Promise.resolve(); // serialise rapid clicks

    function refreshViaTheme(cart) {
      return new Promise(function (resolve) {
        var realOpen = cart.openCartDrawer;
        var finished = false;
        var safetyTimer = null;

        function noopOpen() {}
        function restore() {
          if (finished) return;
          finished = true;
          clearTimeout(safetyTimer);
          document.removeEventListener('theme:cart:added', onAdded);
          if (cart.openCartDrawer === noopOpen) cart.openCartDrawer = realOpen;
          resolve();
        }
        // build() fires theme:cart:added synchronously right BEFORE it calls
        // openCartDrawer(), so restore on the next tick.
        function onAdded() { setTimeout(restore, 0); }

        cart.openCartDrawer = noopOpen;
        document.addEventListener('theme:cart:added', onAdded);
        safetyTimer = setTimeout(restore, RESTORE_SAFETY_MS); // never leave open() disabled

        try { cart.getCart(); } catch (e) { restore(); }
      });
    }

    // Fallback when window.cart isn't available (e.g. the /cart page).
    function refreshViaSectionPatch() {
      return fetch(SECTION_URL, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('cart section ' + r.status)); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelector('[data-api-line-items]');
          var price = doc.querySelector('[data-api-cart-price]');
          var itemsHolder = document.querySelector('[data-items-holder]');
          var priceHolder = document.querySelector('[data-cart-price-holder]');
          if (itemsHolder) itemsHolder.innerHTML = items ? items.innerHTML : '';
          if (priceHolder && price) priceHolder.innerHTML = price.innerHTML;
          var qty = 0;
          (items ? items.querySelectorAll('[data-quantity-field]') : []).forEach(function (f) { qty += parseInt(f.value, 10) || 0; });
          var qtyEl = document.querySelector('[data-cart-items-qty]');
          if (qtyEl) qtyEl.textContent = qty + (qty === 1 ? ' item' : ' items');
          document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (b) { b.classList.toggle('cart__toggle--has-items', qty > 0); });
          document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
        })
        .catch(function () { /* item is already in the cart; UI refresh is best-effort */ });
    }

    function silentRefresh() {
      var run = function () {
        var cart = window.cart;
        if (cart && typeof cart.getCart === 'function') return refreshViaTheme(cart);
        return refreshViaSectionPatch();
      };
      queue = queue.then(run, run);
      return queue;
    }

    // Mage's sidebar assigns window.__mageRefreshCart when it mounts (lazily)
    // and would clobber a plain assignment; an accessor with a no-op setter
    // keeps ours in place.
    Object.defineProperty(window, '__mageRefreshCart', {
      configurable: true,
      enumerable: true,
      get: function () { return silentRefresh; },
      set: function () {},
    });

    window.MageCartRefresh = { refresh: silentRefresh }; // console: MageCartRefresh.refresh()
  })();

// ---------------------------------------------------------------------------
  // Mage Loyalty: wishlist heart correct variant id for collection pages
  //
  // Without this fix, all collection hearts have the same variant id. This script
  // ensures all collection page hearts are attributed the correct variant id. 
  // ---------------------------------------------------------------------------
(function () {
  function sync(root) {
    (root.querySelectorAll ? root : document).querySelectorAll('[data-product-block][data-variant-id]').forEach(function (card) {
      var vid = card.getAttribute('data-variant-id');
      if (!/^\d+$/.test(vid)) return;
      card.querySelectorAll('mage-wishlist-heart').forEach(function (h) {
        if (h.getAttribute('variant-id') !== vid) h.setAttribute('variant-id', vid);
      });
    });
  }
  function start() {
    sync(document);
    new MutationObserver(function () { sync(document); }).observe(document.body, { childList: true, subtree: true });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();